var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactNumberInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 267",
    style: {
      fill: "transparent"
    },
    d: "M0 0h20v20H0z",
    transform: "rotate(180 10 10)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1356",
    d: "M88.011 28.361a5.37 5.37 0 0 1-.405-2.3 2 2 0 0 1 .6-1.279l1.151-1.151a1.1 1.1 0 0 1 1.641 0c.32.3.618.618.938.938l.917.917a1.087 1.087 0 0 1 0 1.684c-.384.384-.746.767-1.151 1.13a.234.234 0 0 0-.064.3 6.979 6.979 0 0 0 1.023 1.663 12.023 12.023 0 0 0 2.878 2.622c.234.149.512.256.746.405a.239.239 0 0 0 .32-.064l1.151-1.151a1.069 1.069 0 0 1 1.641 0l1.854 1.854a1.115 1.115 0 0 1 0 1.684c-.341.362-.725.682-1.045 1.066a2.109 2.109 0 0 1-1.791.682 7.68 7.68 0 0 1-2.792-.831 15.326 15.326 0 0 1-5.116-4.007 14.2 14.2 0 0 1-2.494-4.157zm8.548-.533a6.256 6.256 0 1 1 1.535 1.279l-.021-.021a3.552 3.552 0 0 1-2.686.725.25.25 0 0 1-.064-.469 3.058 3.058 0 0 0 1.3-1.471zm3.965-7.034a1.023 1.023 0 1 0 1.023-1.023 1.01 1.01 0 0 0-1.023 1.023zm-.981 1.727a.226.226 0 0 0 .171.256 1.911 1.911 0 0 0 .341.064c.256.043.341.128.341.405v.128c-.107.64-.234 1.279-.341 1.918a20.19 20.19 0 0 0-.171 1.108 1.113 1.113 0 0 0 .853 1.108 4.377 4.377 0 0 0 .746.043 1.9 1.9 0 0 0 1.364-.618.513.513 0 0 0 .149-.256.16.16 0 0 0-.234-.192c-.107.043-.192.107-.3.149a2.583 2.583 0 0 1-.384.107.282.282 0 0 1-.32-.213 1.008 1.008 0 0 1-.021-.362c.021-.234.085-.49.128-.725.128-.725.277-1.471.405-2.2a2.838 2.838 0 0 0 .064-.6.342.342 0 0 0-.384-.362h-1.94a.877.877 0 0 0-.234.021c-.149.042-.214.106-.235.213z",
    transform: "translate(-87.563 -17.362)",
    style: {
      fill: "#a39d99"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNumberInfo);
export default __webpack_public_path__ + "static/media/contact-number-info.ab27be4c66727253aacc7e98bd6c4bea.svg";
export { ForwardRef as ReactComponent };